import React, { Component } from 'react'
import {
    Card,
    Row,
    Col,
    Button,
    Modal,
    Select,
    Empty,
    Input,
    Alert,
    message
} from 'antd'
import {
    AppstoreAddOutlined,
    PlusOutlined,
    DeleteOutlined
} from '@ant-design/icons'
import styled from 'styled-components'
import cloneDeep from 'lodash/cloneDeep'
import {
    getLayouts,
    setLayouts,
    removeLayout,
    getColumns,
    setColumns
} from '../../services/apiServices'
import { generateMenuListAuto } from '../../services/appServices'
import DragBoard from './DragBoard/DragBoard'
import RowEditor from './RowEditor/RowEditor'
import SaveButton from './../../commons/Button/SaveButton'
import LoadingModal from '../../commons/Modal/Loading'
import ColumnSelector from './../Column/ColumnEditor/ColumnSelector'
import ColumnEditor from './../Column/ColumnEditor/ColumnEditor'
import LayoutAddModal from './LayoutAddModal/LayoutAddModal'

const { Option } = Select

const Container = styled(Card)``

class Column extends Component {
    state = {
        isLoading: false,
        isRefreshing: false,
        selectedLayoutSet: 'home',
        layoutSets: [],
        columns: [],
        actionType: '',
        isOpenLayoutAddModal: false,
        isOpenRowEditor: false,
        isOpenColumnSelector: false,
        isOpenColumnEditor: false,
        selectedRow: {},
        selectedColumn: {},
        selectedColumnType: 0,
        selectedIndexList: [],
        selectedColumnIndexList: []
    }

    componentDidMount() {
        this.getColumns()
        this.getLayouts()
    }

    async getLayouts(callback) {
        this.setState({ isLoading: true })
        try {
            let layoutSets = await getLayouts()
            this.setState(
                {
                    isLoading: false,
                    layoutSets
                },
                () => {
                    callback && callback()
                }
            )
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setLayouts(name, callback) {
        this.setState({ isLoading: true })
        try {
            let layoutSets = await setLayouts({
                body: { name }
            })
            this.setState(
                {
                    isLoading: false,
                    layoutSets
                },
                () => {
                    callback && callback(layoutSets)
                }
            )
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async removeLayout(callback) {
        this.setState({ isLoading: true })
        try {
            let layoutSets = await removeLayout({
                body: { id: this.state.selectedLayoutSet }
            })
            this.setState(
                {
                    isLoading: false,
                    selectedLayoutSet: 'home',
                    layoutSets
                },
                () => {
                    callback && callback(layoutSets)
                }
            )
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async getColumns(callback) {
        this.setState({ isLoading: true })
        try {
            let columns = await getColumns({
                body: { id: this.state.selectedLayoutSet }
            })
            this.setState(
                {
                    isLoading: false,
                    columns
                },
                () => {
                    callback && callback()
                }
            )
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    async setColumns(data = [], callback) {
        this.setState({ isLoading: true })
        try {
            let columns = await setColumns({
                body: { id: this.state.selectedLayoutSet, columns: data }
            })
            this.setState(
                {
                    isLoading: false,
                    columns
                },
                () => {
                    callback && callback()
                }
            )
        } catch (error) {
            this.setState({ isLoading: false })
            message.error(this.props.T('SOMETHING_WRONG'))
        }
    }

    onSave() {
        let { columns } = this.state
        this.setColumns(columns, () => {
            message.success(this.props.T('SAVED'))
            this.setState({ isRefreshing: true }, () => {
                this.setState({ isRefreshing: false })
            })
        })
    }

    setBlocks(blocks) {
        this.setState({
            columns: blocks
        })
    }

    onRemoveAll() {
        showRemoveAllConfirm(this.props.T.bind(this), () => {
            this.setState({ columns: [] })
        })
    }

    onToggleLayoutAddModal(status) {
        this.setState({
            isOpenLayoutAddModal: status
        })
    }

    onSubmitLayout(name) {
        this.onToggleLayoutAddModal(false)
        this.setLayouts(name, list => {
            let layout = list[list.length - 1]
            this.setState(
                {
                    selectedLayoutSet: layout.id
                },
                () => this.getColumns()
            )
        })
    }

    onRemoveLayout() {
        showRemoveLayoutConfirm(this.props.T.bind(this), () => {
            this.removeLayout(() => this.getColumns())
        })
    }

    onChangeLayout(id) {
        showChangeLayoutConfirm(this.props.T.bind(this), () => {
            this.setState(
                {
                    selectedLayoutSet: id
                },
                () => this.getColumns()
            )
        })
    }

    onAddRow() {
        this.setState(
            {
                actionType: 'ADD',
                selectedRow: {},
                selectedIndexList: []
            },
            () =>
                this.onSubmitRow({
                    fullscreen: false,
                    paddingTop: 0,
                    paddingBottom: 0,
                    colors: '',
                    image: '',
                    cssClass: ''
                })
        )
    }

    onEditRow(indexList, row) {
        this.setState(
            {
                actionType: 'EDIT',
                selectedRow: row,
                selectedIndexList: indexList
            },
            () => this.onToggleRowEditor(true)
        )
    }

    onRemoveRow(indexList) {
        showRemoveRowConfirm(this.props.T.bind(this), () => {
            let newColumns = cloneDeep(this.state.columns)
            newColumns.splice(indexList[0], 1)
            this.setState({ columns: newColumns })
        })
    }

    onSubmitRow(row) {
        let { actionType, selectedIndexList, columns } = this.state
        let indexList = [...selectedIndexList]
        let data = {
            fullscreen: row.fullscreen,
            pt: row.paddingTop,
            pb: row.paddingBottom,
            background_colors: row.colors,
            background_image: row.image,
            css_class: row.cssClass
        }

        let newColumns = cloneDeep(columns)

        if (actionType == 'EDIT') {
            newColumns[indexList[0]] = {
                ...newColumns[indexList[0]],
                ...data
            }
        } else if (actionType == 'ADD') {
            newColumns.push({
                ...data,
                block_type: 'row',
                columns: []
            })
        }

        this.setState({ columns: newColumns }, () => {
            this.onToggleRowEditor(false)
            if (actionType == 'ADD') {
                setTimeout(() => {
                    let layoutContent =
                        document.querySelector('.layount-content')
                    if (layoutContent) {
                        layoutContent.scrollTo(0, layoutContent.scrollHeight)
                    }
                }, 100)
            }
        })
    }

    onToggleColumnSelector(status) {
        this.setState({
            isOpenColumnSelector: status
        })
    }

    onAddColumn(indexList) {
        this.setState(
            {
                selectedIndexList: indexList
            },
            () => this.onToggleColumnSelector(true)
        )
    }

    onSelectColumn(type) {
        this.setState(
            {
                selectedColumnType: type,
                selectedColumn: {},
                selectedColumnIndexList: [],
                isOpenColumnSelector: false
            },
            () => {
                this.onToggleColumnEditor(true)
            }
        )
    }

    onEditColumn(indexList, column = {}) {
        this.setState(
            {
                selectedColumnType: column.type,
                selectedColumnIndexList: indexList,
                selectedColumn: column
            },
            () => this.onToggleColumnEditor(true)
        )
    }

    onRemoveColumn(indexList = []) {
        if (indexList.length == 2) {
            showRemoveColumnConfirm(this.props.T.bind(this), () => {
                let newColumns = cloneDeep(this.state.columns)
                newColumns[indexList[0]].columns.splice(indexList[1], 1)
                this.setState({ columns: newColumns })
            })
        }
    }

    onToggleRowEditor(status) {
        this.setState({
            isOpenRowEditor: status
        })
    }

    onToggleColumnEditor(status) {
        this.setState({
            isOpenColumnEditor: status
        })
    }

    onSubmitColumnEditor(column = {}) {
        let { selectedColumnIndexList, selectedIndexList } = this.state
        let columns = cloneDeep(this.state.columns)
        column.block_type = 'column'
        column.has_changed = true
        if (
            selectedColumnIndexList.length == 0 &&
            selectedIndexList.length == 1
        ) {
            columns[selectedIndexList[0]].columns.push(column)
        } else if (selectedColumnIndexList.length == 2) {
            columns[selectedColumnIndexList[0]].columns[
                selectedColumnIndexList[1]
            ] = column
        }
        this.setState({ columns }, () => this.onToggleColumnEditor(false))
    }

    render() {
        let { T } = this.props
        return (
            <>
                <Row type="flex" justify="start" style={{ marginBottom: 15 }}>
                    <Col>
                        <b>{T('LAYOUT')}:</b>
                        <Select
                          size="large"
                            value={this.state.selectedLayoutSet}
                            style={{
                                width: 200,
                                marginRight: 10,
                                marginLeft: 10
                            }}
                            onChange={id => this.onChangeLayout(id)}>
                            {this.state.layoutSets.map(set => (
                                <Option key={set.id} value={set.id}>
                                    {set.name}
                                </Option>
                            ))}
                        </Select>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            size="large"
                            icon={<PlusOutlined />}
                            style={{ marginRight: 10 }}
                            onClick={() => this.onToggleLayoutAddModal(true)}>
                            {T('ADD_LAYOUT')}
                        </Button>
                        <Button
                            type="danger"
                            size="large"
                            disabled={this.state.selectedLayoutSet == 'home'}
                            icon={<DeleteOutlined />}
                            style={{ marginRight: 10 }}
                            onClick={() => this.onRemoveLayout()}>
                            {T('REMOVE')}
                        </Button>
                    </Col>
                    <Col
                        style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                        <b style={{ marginRight: 10 }}>Shortcode:</b>
                        <Alert
                            style={{ textAlign: 'center' }}
                            message={`[indymall_layout id="${this.state.selectedLayoutSet}"]`}
                            type="success"
                        />
                    </Col>
                </Row>
                <Container
                    title={
                        <span className="text-xl">
                            <AppstoreAddOutlined /> {T('COLUMN')}
                        </span>
                    }
                    extra={
                        <>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                style={{ marginRight: 10 }}
                                onClick={() => this.onAddRow()}>
                                {T('ADD_ROW')}
                            </Button>
                            {this.state.columns.length > 0 && (
                                <Button
                                    type="danger"
                                    icon={<DeleteOutlined />}
                                    style={{ marginRight: 10 }}
                                    onClick={() => this.onRemoveAll()}>
                                    {T('CLEAR_ALL')}
                                </Button>
                            )}
                        </>
                    }>
                    {this.state.isRefreshing ||
                    (!this.state.isLoading &&
                        this.state.columns.length == 0) ? (
                        <Empty />
                    ) : (
                        <Row type="flex" justify="center">
                            <Col
                                xs={24}
                                md={24}
                                lg={16}
                                className="layount-content">
                                <DragBoard
                                    T={T}
                                    columns={this.state.columns}
                                    setBlocks={this.setBlocks.bind(this)}
                                    setState={this.setState.bind(this)}
                                    onEditRow={this.onEditRow.bind(this)}
                                    onRemoveRow={this.onRemoveRow.bind(this)}
                                    onAddColumn={this.onAddColumn.bind(this)}
                                    onEditColumn={this.onEditColumn.bind(this)}
                                    onRemoveColumn={this.onRemoveColumn.bind(
                                        this
                                    )}
                                />
                            </Col>
                        </Row>
                    )}

                    <RowEditor
                        T={T}
                        isOpen={this.state.isOpenRowEditor}
                        row={this.state.selectedRow}
                        onSubmit={this.onSubmitRow.bind(this)}
                        onClose={() => this.onToggleRowEditor(false)}
                    />

                    <ColumnSelector
                        T={T}
                        isOpen={this.state.isOpenColumnSelector}
                        onSelect={this.onSelectColumn.bind(this)}
                        onClose={() => this.onToggleColumnSelector(false)}
                    />

                    <ColumnEditor
                        T={T}
                        isOpen={this.state.isOpenColumnEditor}
                        columnType={this.state.selectedColumnType}
                        info={this.state.selectedColumn}
                        onSubmit={this.onSubmitColumnEditor.bind(this)}
                        onClose={() => this.onToggleColumnEditor(false)}
                    />

                    <LayoutAddModal
                        T={T}
                        isOpen={this.state.isOpenLayoutAddModal}
                        onSubmit={this.onSubmitLayout.bind(this)}
                        onClose={() => this.onToggleLayoutAddModal(false)}
                    />

                    <LoadingModal isOpen={this.state.isLoading} />

                    <SaveButton T={T} onSubmit={() => this.onSave()} />
                </Container>
            </>
        )
    }
}

const showRemoveRowConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_ROW_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

const showRemoveColumnConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_COLUMN_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

const showRemoveAllConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_LAYOUT_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

const showRemoveLayoutConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_REMOVE_ALL_ROW_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

const showChangeLayoutConfirm = (T, onOk) => {
    Modal.confirm({
        title: T('CONFIRM_CHANGE_LAYOUT_MSG'),
        content: T('WARNING_CHANGE_PAGE_MSG'),
        okType: 'danger',
        okText: T('CONFIRM'),
        cancelText: T('CANCEL'),
        maskClosable: true,
        centered: true,
        onOk() {
            onOk()
        },
        onCancel() {
            console.log('Cancel')
        }
    })
}

export default Column
